import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Icon } from '@elparking/components'

const OptionWrapper = styled.div`
    line-height: 100%;
    overflow: hidden;
    max-width: 100%;
    width: 100%;
    height: 100%;
    white-space: nowrap;
    display: flex;
    align-items: center;
    padding: 0 0.2em;
`

const IconWrapper = styled.span`
    width: 2em;
    text-align: center;
`

OptionWrapper.propTypes = {
    dataTest: PropTypes.string,
}

const OptionText = styled.div`
    display: inline-block;
    font-size: 14px;
    font-weight: 500;
    line-height: 45px;
    margin-left: 10px;
`
const Option = ({text, icon, dataTest, color, iconSize}) => (
    <OptionWrapper dataTest={dataTest}>
        <IconWrapper>
            <Icon type={icon} color={color} size={iconSize} />
        </IconWrapper>
        <OptionText>{ text }</OptionText>
    </OptionWrapper>
)

Option.propTypes = {
    color: PropTypes.string,
    dataTest: PropTypes.string,
    text: PropTypes.string,
    icon: PropTypes.string,
    iconSize: PropTypes.string,
}

Option.defaultProp = {
    color: 'gray',
}

export default Option
